import { Fragment } from 'react';
import { ChevronRight } from 'lucide-react';
import type { StorefrontSection } from '@mlm/shared';

type Cfg = Extract<StorefrontSection, { type: 'howItWorks' }>['config'];

/** Numbered step cards (numerals derived from index) with arrow connectors. */
export function HowItWorksSection({ section }: { section: StorefrontSection }) {
  const cfg = section.config as Cfg;
  const steps = cfg.steps.slice(0, 6);
  return (
    <section className="bg-card py-14">
      <div className="mx-auto max-w-[1100px] px-4 text-center">
        <h2 className="font-heading text-[32px] font-extrabold text-foreground">{cfg.heading}</h2>
        {cfg.subheading && <p className="mt-2 text-sm text-muted-foreground">{cfg.subheading}</p>}
        <div className="mt-9 flex flex-col items-stretch gap-4 lg:flex-row lg:items-center lg:justify-center">
          {steps.map((s, i) => (
            <Fragment key={i}>
              <div className="flex-1 rounded-2xl bg-card p-7 text-center shadow-card transition-transform hover:-translate-y-1">
                <div className="font-heading text-[46px] font-extrabold leading-none text-o/40">
                  {String(i + 1).padStart(2, '0')}
                </div>
                <div className="mt-3 text-[18px] font-bold text-foreground">{s.title}</div>
                <p className="mt-1.5 text-[13px] leading-relaxed text-muted-foreground">{s.body}</p>
              </div>
              {i < steps.length - 1 && (
                <ChevronRight className="mx-auto hidden h-7 w-7 shrink-0 text-primary lg:block" />
              )}
            </Fragment>
          ))}
        </div>
      </div>
    </section>
  );
}
